import {
    BrandVariants,
    GriffelStyle,
    Theme,
    createDarkTheme,
    createLightTheme,
    makeStyles,
    shorthands,
    themeToTokensObject,
    tokens,
} from '@fluentui/react-components';

export const semanticKernelBrandRamp: BrandVariants = {
    10: '#4D1804',
    20: '#601E06',
    30: '#742407',
    40: '#872A08',
    50: '#9A3009',
    60: '#AE360A',
    70: '#C13C0B',
    80: '#D4420C',
    90: '#E7480D',
    100: '#F25218',
    110: '#F25C24',
    120: '#F46F3E',
    130: '#F57D51',
    140: '#F68C65',
    150: '#F79A78',
    160: '#F8A88B',
};

export const semanticKernelLightTheme: Theme & { overlayDrawerBackground: string } & { colorMeBackground: string } & { connectOrange: string } & { connectBlue: string } = {
    ...createLightTheme(semanticKernelBrandRamp),
    overlayDrawerBackground: '#F0F0F0',
    colorMeBackground: '#F6F0F7',
    connectOrange: '#F25C24',
    connectBlue: '#002E61'
};

export const semanticKernelDarkTheme: Theme & { overlayDrawerBackground: string } & { colorMeBackground: string } & { connectOrange: string } & { connectBlue: string } = {
    ...createDarkTheme(semanticKernelBrandRamp),
    overlayDrawerBackground: '#2b2b3e',
    colorMeBackground: '#2b2b3e',
    connectOrange: '#F25C24',
    connectBlue: '#002E61'
};

export const customTokens = themeToTokensObject(semanticKernelLightTheme);

export const Breakpoints = {
    small: (style: GriffelStyle): Record<string, GriffelStyle> => {
        return { '@media (max-width: 744px)': style };
    },
};

export const ScrollBarStyles: GriffelStyle = {
    overflowY: 'auto',
    '&:hover': {
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: tokens.colorScrollbarOverlay,
            visibility: 'visible',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: tokens.colorNeutralBackground1,
            WebkitBoxShadow: 'inset 0 0 5px rgba(0, 0, 0, 0.1)',
            visibility: 'visible',
        },
    },
};

export const SharedStyles: Record<string, GriffelStyle> = {
    scroll: {
        height: '100%',
        ...ScrollBarStyles,
    },
    overflowEllipsis: {
        ...shorthands.overflow('hidden'),
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
};

export const useSharedClasses = makeStyles({
    informativeView: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.padding('80px'),
        alignItems: 'center',
        ...shorthands.gap(tokens.spacingVerticalXL),
        marginTop: tokens.spacingVerticalXXXL,
    },
});

export const useDialogClasses = makeStyles({
    surface: {
        paddingRight: tokens.spacingVerticalXS,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.overflow('hidden'),
        width: '100%',
    },
    paragraphs: {
        marginTop: tokens.spacingHorizontalS,
    },
    innerContent: {
        height: '100%',
        ...SharedStyles.scroll,
        paddingRight: tokens.spacingVerticalL,
    },
    text: {
        whiteSpace: 'pre-wrap',
        textOverflow: 'wrap',
    },
    footer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        minWidth: '175px',
    },
});
